// extracted by mini-css-extract-plugin
export default {"wrapper":"Cp-z","response":"Dp-z","error":"Ep-z","disabled":"Fp-z","buttons":"Gp-z","feedbackQuestionSection":"Hp-z","yesNoWrapper":"Ip-z"};